import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Tabel } from 'src/app/interfaces/auth.interface';


@Component({
  selector: 'app-lets-start',
  templateUrl: './lets-start.component.html',
  styleUrls: ['./lets-start.component.scss']
})
export class LetsStartComponent implements OnInit {

  constructor(private sessionStorge:  LocalStorageService, private as:AuthService, private us:UserService) { }

  userPassedData: Tabel[] = []

  errorMessage:string = ''

  loading:Boolean = true


  ngOnInit() {
    
    // this.as.getUserData().subscribe(data => this.userPassedData = data)

    this.as.getUserDataId().subscribe(data => { 
      this.userPassedData = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
      console.log(this.userPassedData)
    })

    setTimeout(() => {
      this.as.siginup(this.userPassedData[0].email,this.userPassedData[0].password)
             .then(result => {
               this.us.addNewUser(result.user.uid, this.userPassedData[0].tableno, this.userPassedData[0].email)
               this.as.deletUserDataPass(this.userPassedData[0].id)
             })
            .catch(error=>{
              this.loading = false
              this.errorMessage = error.message
              console.log(error)
            })
    }, 4000);

  //   setInterval(()=>{      
  //            this.as.siginup(this.userPassedData[0].email,this.userPassedData[0].password)
  //            .then(result => {
  //              this.us.addNewUser(result.user.uid, this.userPassedData[0].tableno, this.userPassedData[0].email)
  //              this.as.deletUserDataPass(this.userPassedData[0].id)
  //            })
  //           .catch(error=>{
  //             this.loading = false
  //             this.errorMessage = error.message
  //             console.log(error)
  //           })
         
  //  },10000)
  }


   

}
